import { Box } from "@mui/material";
import styled from "styled-components";
import { thirdly2 } from "styles/theme";
import { thirdly } from "styles/theme";
import { white, header, sidebar } from "styles/theme";
import { styled as muiStyled } from '@mui/material/styles';
import { ScrollCss } from "styles/GlobalCss";


const WrapHeader = muiStyled(Box)(({ theme, $systemUI, len, index }) => ({
    height: header,
    padding: 10,
    background: white,
    position: "absolute",
    top: 0,
    display: "flex",
    alignItems: "center",
    width: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    ...ScrollCss,
    borderBottom: `1px solid ${thirdly2}`,
    boxSizing: "border-box",
    [theme.breakpoints.down('md')]: {
        paddingLeft: 80
    }
}));


const WrapPullDown = styled.div`
`

const WrapContent = muiStyled(Box)(({ theme, $systemUI, len, index }) => ({
    marginLeft: `${sidebar + 10}px`,
    display: "flex",
    columnGap: 15,
    alignItems: "center",
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    padding: "4px 0px",
    [theme.breakpoints.down('md')]: {
        marginLeft: 0
    }
}));

export { WrapHeader, WrapPullDown, WrapContent }